// DATE_FORMAT is used in Review screen of Change Subscription pane
export const DATE_FORMAT = 'LLL dd, yyyy';
